export function isHomeAppRoute(pathname: string): boolean {
  const p = String(pathname || '');
  return p === '/app' || p === '/app/';
}
